import { NgModule } from '@angular/core';
import { BrowserModule, HammerModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FloorLayoutComponent } from './components/floor-layout/floor-layout.component';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { PlanPreviewComponent } from './components/view-types/plan-preview/plan-preview.component';
import { HttpClientModule } from '@angular/common/http';
import { PinchZoomModule } from './components/utilities/pinch-zoom/pinch-zoom.module';
import { ThemeColorSelectorPipe } from './pipes/theme-color-selector.pipe';
import { SvgFactoryComponent } from './components/assets-factory/svg-factory/svg-factory.component';
import { PlanBuilderComponent } from './components/plan-builder/plan-builder.component';
import { PolygonFactoryComponent } from './components/assets-factory/polygon-factory/polygon-factory.component';
import { AdminViewerComponent } from './components/view-types/admin-viewer/admin-viewer.component';
import { EmployeeViewerComponent } from './components/view-types/employee-viewer/employee-viewer.component';
import { BookingDetailsHolderComponent } from './components/utilities/booking-details-holder/booking-details-holder.component';
import { FormatDateTimePipe } from './pipes/format-date-time.pipe';
import { InteractionsInjectionComponent } from './components/assets-factory/interactions-injection/interactions-injection.component';
import { TeamToolTipComponent } from './components/utilities/team-tool-tip/team-tool-tip.component';

@NgModule({
  declarations: [
    AppComponent,
    FloorLayoutComponent,
    WelcomeComponent,
    PlanPreviewComponent,
    ThemeColorSelectorPipe,
    PolygonFactoryComponent,
    SvgFactoryComponent,
    PlanBuilderComponent,
    AdminViewerComponent,
    EmployeeViewerComponent,
    BookingDetailsHolderComponent,
    FormatDateTimePipe,
    InteractionsInjectionComponent,
    TeamToolTipComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    HammerModule,
    PinchZoomModule
  ],
  exports:[FloorLayoutComponent],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
